<template>
  <div class="c-favorite-hotels u-box-shadow">
    <h2 class="title is-4 has-text-centered" style="width: 100%">
      {{ $t("favoriteHotels") }}
    </h2>

    <p v-if="!hotels || hotels.length == 0">
      {{ $t("favoriteHotelsNoHotels") }}
    </p>
    <div
      v-else
      class="c-favorite-hotels__suggestion"
      v-for="hotel in hotels"
      @click="gotoHotel(hotel)"
      :key="hotel.name"
    >
      <img :src="hotel.thumbnail" />
      <a class="u-text-color-brand">{{ hotel.name }} </a>
    </div>
  </div>
</template>

<script>
import commonHelper from "@/helpers/common.helper";
import moment from "moment";

export default {
  data() {
    return {
      hotels: []
    };
  },
  async created() {
    const companyInfo = await commonHelper.getCompanyInfo();

    const hotels = companyInfo.favoriteHotels;

    this.hotels = hotels;
  },
  methods: {
    gotoHotel(hotel) {
      this.track("favoriteHotelClick", {
        hotelName: hotel.name,
        hotelCity: hotel.city,
        hotelPostalCode: hotel.postalCode,
        hotelId: hotel.id,
        hotelStreet: hotel.street
      });

      const fauxDate = moment().add("4", "days").format("YYYY-MM-DD");
      this.$router.push({
        name: this.PAGES.HotelDetail,
        params: {
          //locationPath: hotel.city,
          locationPath: "direct",
          hotelId: hotel.id,
          checkin: fauxDate,
          nights: 1,
          rooms: 1,
          adults: 1
        }
      });
    }
  }
};
</script>
